<div id="state-of-car-management" uk-modal>
    <div class="uk-modal-dialog wrap wrap-width">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div class="uk-modal-body" *ngIf="loading === false">
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <h2 class="main-title bold color-grey uk-text-uppercase uk-margin-small-bottom">
                    <span *ngIf="selectedState.type === 2">États des lieux d'entrée</span>
                    <span *ngIf="selectedState.type === 1">Sinistres & états des lieux</span>
                    <span *ngIf="selectedState.type === 0">États des lieux de sortie</span>
                </h2>
                <a href="#" [routerLink]="['/ressource/vehicle/informations/' + selectedState.idVehicle ]" style="width: max-content;"
                class="main-title regular color-cold-grey links uk-display-block pointer uk-modal-close uk-margin-bottom">
                    {{ selectedState.vehicle.name }}
                </a>
                <div uk-grid class="uk-grid-small">
                    <a href="#" class="uk-margin-small-bottom uk-margin-small-top uk-display-inline-block pointer uk-modal-close"
                    [routerLink]="['/user/informations/' + selectedState.societyVopUser.AccountId ]"
                    *ngIf="selectedState.societyVopUser.FirstName.length !== 0 && selectedState.societyVopUser.LastName.length !== 0">
                        <img src="../../../../assets/icons/User.svg" width="40px" height="40px" class="vertical-align-middle">
                        <span class="vertical-align-middle color-dark-turquoise bold uk-text-uppercase">
                            {{ selectedState.societyVopUser.FirstName }} {{ selectedState.societyVopUser.LastName }}
                        </span>
                    </a>
                    <div class="uk-margin-small-bottom uk-margin-small-top uk-display-inline-block"
                    *ngIf="selectedState.ISOCreated.length !== 0">
                        <img src="../../../../assets/icons/Booking.svg" width="40px" height="40px">
                        <span class="vertical-align-middle color-cold-grey regular uk-text-uppercase">
                            Déclaré le <span humanDateFormat="{{ selectedState.ISOCreated }}" shortened="true" class="bold"></span> à {{selectedState.ISOCreated | date:'HH:mm'}}
                        </span>
                    </div>
                    <a href="#" class="uk-margin-small-bottom uk-margin-small-top uk-display-inline-block pointer uk-modal-close"
                    *ngIf="selectedState.idBooking > 0"
                    [routerLink]="['/reservation/informations/' + selectedState.idBooking ]">
                        <img src="../../../../assets/icons/Booking.svg" width="40px" height="40px">
                        <span class="vertical-align-middle color-dark-turquoise bold uk-text-uppercase">
                            Réservation #{{ selectedState.idBooking }}
                        </span>
                    </a>
                </div>
                <div uk-grid style="min-height: 500px; margin-top: 0px;">
                    <div class="uk-width-8-12@s uk-grid-small@s" uk-grid>
                        <div *ngFor="let state of statesOfCar; let i = index" [ngClass]="{
                            'uk-width-6-12' : statesOfCar.length > 1,
                            'uk-width-12-12' : statesOfCar.length === 1
                        }">
                            <div class="img-wrap pictureMobile" uk-lightbox>
                                <a class="uk-button uk-button-default" [href]="state.imgs[0]">
                                    <span *ngIf="state.part === 1" class="tag bold">Avant</span>
                                    <span *ngIf="state.part === 2" class="tag bold">Arrière</span>
                                    <span *ngIf="state.part === 3" class="tag bold">Gauche</span>
                                    <span *ngIf="state.part === 4" class="tag bold">Droite</span>
                                    <img [src]="state.imgs[0]" onerror="this.src='../../../../assets/img/no-photo.png';this.className='img-error';">
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-4-12@s uk-width-1-1">
                        <div class="uk-form-stacked">
                            <div class="uk-margin" *ngFor="let state of statesOfCar" [ngClass]="{
                                'display-none' : state.comment.length === 0
                            }">
                                <label class="label">Commentaire
                                    (<span *ngIf="state.part === 1">avant</span>
                                    <span *ngIf="state.part === 2">arrière</span>
                                    <span *ngIf="state.part === 3">gauche</span>
                                    <span *ngIf="state.part === 4">droite</span>)
                                </label>
                                <div class="uk-form-controls uk-margin-small-top" >
                                    <span class="color-cold-grey bold">{{ state.comment }}</span>
                                </div>
                            </div>
                            <div>
                                <label class="label">Statut</label>
                                <div class="uk-form-controls uk-margin-small-top">
                                    <select class="combo-list alt color-cold-grey bold" [(ngModel)]="status" style="width: 250px;">
                                        <option value="0">Nouveau</option>
                                        <option value="1">À traiter</option>
                                        <option value="2">Archivé</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-modal-footer">
            <p class="uk-text-right">
                <button class="button bold uk-modal-close" type="button">Annuler</button>
                <button class="button bold uk-margin-small-left" type="submit" (click)="updateStatus()">
                    Sauvegarder
                </button>
            </p>
        </div>
    </div>
</div>